const EMBEDDING_MODEL = {
    jina : 'Jina'
};

const CHUNKING_STRATEGY = {
    'by page': 'By Page'
};

export const COLLECTION_PROCESS_STATUS = {
    completed: 'Processed',
    processing: 'Processing',
    success: 'Processed',
    error : 'Errors occurred',
    checking : 'Checking...',
    idle : 'Idle',
    cancelled : 'Cancelled',
};
export const PROCESS_LEVEL = {
    1: 'L1',
    2: 'L2'
};
export const STATUS_FILTER = {
    '' : 'All',
    unprocessed : 'New',
    failed : 'Failed',
};

/**
 * Translates the data returned by the database to a more suitable one for displaying
 * @param {"jina"} embeddingModel
 * @returns
 */
export function translateEmbeddingModel(embeddingModel) {
    const translated = EMBEDDING_MODEL[embeddingModel];
    if (translated) return translated;
    console.warn('Embedding model not mapped to UI.', embeddingModel, 'Returning --');
    return '--';
}

/**
 * Translates the data returned by the database to a more suitable one for displaying
 * @param {"by page"} chunkingStrategy
 * @returns
 */
export function translateChunkingStrategy(chunkingStrategy) {
    const translated = CHUNKING_STRATEGY[chunkingStrategy];
    if (translated) return translated;
    console.warn('Chunking strategy not mapped to UI.', chunkingStrategy, 'Returning --');
    return '--';
}